import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'messageType',
    'organizationId',
    'assignEl',
    'informEl',
    'closeAssignElBtn',
    'assignElBtn',
    'informElBtn',
    'closeInformElBtn',
    'supportContent',
    'feedbackContent',
    'patientContent',
    'patientSelect',
  ];

  static values = { url: String };

  toggleAssignView() {
    this.assignElTarget.classList.toggle('d-none');
    this.assignElBtnTarget.classList.toggle('d-none');
    this.closeAssignElBtnTarget.classList.toggle('d-none');
  }

  toggleInformView() {
    this.informElTarget.classList.toggle('d-none');
    this.informElBtnTarget.classList.toggle('d-none');
    this.closeInformElBtnTarget.classList.toggle('d-none');
  }

  typeChange(event) {
    this.supportContentTarget.classList.toggle('d-none');
    this.feedbackContentTarget.classList.toggle('d-none');
  }

  orgChange(event) {
    // Hide select container if organization value is not the same as current_org
    this.patientContentTarget.classList.toggle('d-none', event.target.selectize.getValue() !== this.currentOrgId);
    this.patientSelectTarget.selectize.clear();
    this.patientSelectTarget.selectize.clearOptions();
  }
}
